

export const SaveCurrentTime = (dateKey) => {
    // current date/time
    let currentDate = new Date();

    // convert date to string
    let dateString = currentDate.toString();

    // save string to local storage
    localStorage.setItem(dateKey, dateString);
}

export const GetHoursDifference = (dateKey) => {
    // get string from local storage
    let retrievedDateString = localStorage.getItem(dateKey);

    // convert string back to date
    // @ts-ignore
    let retrievedDate = new Date(retrievedDateString);

    // get current date/time
    let currentDate = new Date();

    // get difference in milliseconds
    // @ts-ignore
    let diff = currentDate - retrievedDate;

    // convert diff to hours
    let hours = diff / (1000 * 60 * 60);

    return hours;
}

export const GetSecondsDifference = (dateKey) => {
    // get string from local storage
    let retrievedDateString = localStorage.getItem(dateKey);

    // convert string back to date
    // @ts-ignore
    let retrievedDate = new Date(retrievedDateString);

    // get current date/time
    let currentDate = new Date();

    // get difference in milliseconds
    // @ts-ignore
    let diff = currentDate - retrievedDate;

    // convert diff to seconds
    let hours = diff / (1000);

    return hours;
}

export const SetLang = (lang) => {
    localStorage.setItem('lang', lang);
}

export const GetLang = (lang) => {
    if(lang)
        SetLang(lang)

    let savedLang = localStorage.getItem('lang')

    if(!savedLang){
        savedLang = 'esMX'
        SetLang(savedLang)
    }

    return savedLang
}

export const SetMenuData = (data) => {
    localStorage.setItem('menuData', data);
}

export const GetMenuData = () => {
    let savedData = localStorage.getItem('menuData')

    return savedData
}

export const ClearMenuData = () => {
    localStorage.removeItem('menuData');
}